import React from 'react';
import { motion } from 'framer-motion';
import './Hero.css';

const Hero = () => {
return (
    <motion.section
        id="hero"
        initial={{ opacity: 0, y: -50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1 }}
        className="hero"
    >
        <div className="hero-content">
            <h1>
                Hello, I'm <span className="highlight">Sanoj Shrestha</span>
            </h1>
            <p>
                I'm a passionate computer engineer who loves building amazing things. 
                With a strong foundation in software development, I specialize in creating 
                efficient and scalable applications. My expertise spans across various 
                programming languages and frameworks, and I am always eager to learn and 
                adapt to new technologies.
            </p>
            <a href="#about" className="cta-button">Learn More</a>
        </div>
    </motion.section>
);
};

export default Hero;